var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06524 17.2502C3.04656 15.3471 2.74581 13.1413 3.21782 11.0349C3.68983 8.92859 4.90317 7.06205 6.63658 5.77566C8.36999 4.48928 10.508 3.86875 12.6608 4.02723C14.8135 4.18571 16.8376 5.11263 18.364 6.63898C19.8903 8.16533 20.8173 10.1894 20.9757 12.3422C21.1342 14.495 20.5137 16.633 19.2273 18.3664C17.9409 20.0998 16.0744 21.3131 13.968 21.7851C11.8617 22.2571 9.65584 21.9564 7.75274 20.9377L4.28274 21.9577C4.11044 22.0083 3.92769 22.0116 3.75368 21.9672C3.57968 21.9228 3.42085 21.8323 3.29387 21.7053C3.16688 21.5784 3.07644 21.4195 3.03203 21.2455C2.98762 21.0715 2.99089 20.8888 3.04149 20.7165L4.06524 17.2502Z",
    fill: "url(#paint0_linear_2259_17965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4928 10.0137C22.0047 10.0959 23.4714 10.5582 24.7572 11.3578C26.043 12.1574 27.1062 13.2685 27.8485 14.5882C28.5908 15.9079 28.9882 17.3936 29.0038 18.9076C29.0194 20.4217 28.6527 21.9152 27.9378 23.2499L28.9578 26.7199C29.0084 26.8922 29.0117 27.075 28.9673 27.249C28.9229 27.423 28.8324 27.5818 28.7054 27.7088C28.5785 27.8358 28.4196 27.9262 28.2456 27.9706C28.0716 28.015 27.8889 28.0118 27.7166 27.9612L24.2503 26.9374C23.1053 27.5498 21.8414 27.9073 20.5453 27.9855C19.2492 28.0637 17.9515 27.8606 16.7411 27.3904C15.5308 26.9201 14.4365 26.1936 13.5332 25.2608C12.6299 24.3281 11.939 23.211 11.5078 21.9862",
    stroke: "url(#paint1_linear_2259_17965)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2259_17965",
    x1: 3,
    y1: 4.00293,
    x2: 23.8401,
    y2: 8.33245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28814D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2259_17965",
    x1: 11.5078,
    y1: 10.0137,
    x2: 31.8101,
    y2: 14.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28814D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.defa6e648eb52f090d6817dc061e6a3a.svg";
export { ForwardRef as ReactComponent };